import classNames from 'classnames'
// Components
import Checkbox from 'components/form/checkbox'
import { Link } from 'components/link'
// Modules
import { DI } from 'modules'
import * as React from 'react'
// Hooks
import { usePaymentSidebar } from '../sidebar.hooks'
import { planPrice } from 'pages/static/choose-plan'

const PERIOD = {
  ANNUALLY: 'annually',
  MONTHLY: 'monthly',
}

const PaymentSidebarSubscription = ({
  actions,
  common,
  pending,
  taxes,
  videos,
  user,
  disabled,
}) => {
  // Setup
  const { strings } = common
  const plan = common.searchParams.plan || ''
  const [, , period] = plan.split('-')
  const prices = taxes.prices.payload

  // console.log(taxes);

  const rootCln = 'buying-side'
  const costCln = `${rootCln}-cost`

  const prefix = 'page.payment.summary'
  const costPrefix = `${prefix}.pass.cost`
  const passPrefix = `${prefix}.pass`
  const agreementId = common.searchParams.agreement_id || ''
  const agreement = user.agreements.payload.find((agr) => agr.id == agreementId)
  const buttonText = agreement ? 'order' : 'send_request'

  // State
  const isMonthly = period === PERIOD.MONTHLY

  // Hooks
  const { handleAgreeChange, isChecked } = usePaymentSidebar(false, {
    actions,
    common,
    videos,
  })

  return (
    <>
      <span className={`${rootCln}__title`}>
        {strings[`${passPrefix}.title`]}
      </span>
      <span className={`${rootCln}__pass`}>
        {strings[`${passPrefix}.pass`]}
      </span>

      <div className={`${rootCln}__info`}>
        <p>
          {strings[`${passPrefix}.info_1`]}
          <Link
            className="text-button j-popup-link"
            rel="noreferrer noopener"
            target="_blank"
            to="/terms-of-use"
          >
            {strings[`${passPrefix}.info.link`]}
          </Link>
        </p>
        <p>{strings[`${passPrefix}.info_2`]}</p>
      </div>

      <div className={costCln}>
        {(typeof prices.tax === 'number' || !user.isSignedIn) && (
          <>
            <span className={`${costCln}__base-text`}>
              {strings[`${costPrefix}.text`]}
            </span>

            <span className={`${costCln}__base`}>
              ${prices.pure_price || planPrice.annually}&nbsp;
              {strings[`${costPrefix}.per`]}&nbsp;
              {strings[`${costPrefix}.${isMonthly ? 'month' : 'year'}`]}
            </span>

            <span className={`${costCln}__annually`}>
              {strings[`${costPrefix}.payed`]} {period}
            </span>

            {prices.tax > 0 && (
              <span className={`${costCln}__vat j-billing-vat-text`}>
                {prices.tax}% VAT: ${prices.tax_value}
              </span>
            )}
          </>
        )}

        <div className={`${costCln}-auto`}>
          <span className={`${costCln}-auto__info`}>
            {strings[`${costPrefix}.info`]}
          </span>
        </div>

        <span className={`${costCln}-total`}>
          <span className={`${costCln}__today`}>
            {strings['page.payment.summary.cost.today']}:
          </span>

          <span className={`${costCln}__today-cost`}>
            ${prices.price || planPrice.annually}
          </span>
        </span>

        <div className="field field--su-checkbox">
          <Checkbox
            checked={isChecked}
            disabled={disabled}
            onChange={handleAgreeChange}
            value={isChecked}
          >
            {strings[`${prefix}.pass.check_agree`]}
          </Checkbox>
        </div>
      </div>

      <div className={`${rootCln}-buttons`}>
        <div className={`${rootCln}-button`}>
          <button
            className={classNames('button', 'button-small-green', {
              loading: pending,
            })}
            disabled={pending || !isChecked || disabled}
            tabIndex={0}
            type="submit"
          >
            {strings[`${prefix}.${buttonText}`]}

            <span className="button__loading">
              {strings[`${prefix}.processing`]}
            </span>
          </button>
        </div>

        <div className={`${rootCln}-buttons`}>
          <Link className={`${rootCln}__cancel`} to="/plans">
            {strings[`${prefix}.order_latter`]}
          </Link>
        </div>
      </div>
    </>
  )
}

export default DI(['common', 'taxes', 'videos', 'user'])(
  PaymentSidebarSubscription
)
